import { render, staticRenderFns } from "./UserDashboardLeadItem.vue?vue&type=template&id=5370a603&scoped=true&"
import script from "./UserDashboardLeadItem.vue?vue&type=script&lang=js&"
export * from "./UserDashboardLeadItem.vue?vue&type=script&lang=js&"
import style0 from "./UserDashboardLeadItem.vue?vue&type=style&index=0&id=5370a603&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5370a603",
  null
  
)

export default component.exports